var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-card",staticStyle:{"width":"100%","margin-bottom":"10px"}},[_c('vue-phone-number-input',{staticClass:"input",attrs:{"border-radius":20,"color":"#cdc9ff","valid-color":"#5669fb","error-color":"red","default-country-code":_vm.country,"translations":{
			countrySelectorLabel: 'Código de país',
			countrySelectorError: 'Elige un país',
			phoneNumberLabel: 'Número de teléfono',
			example: 'Ejemplo :',
		}},on:{"update":_vm.sendData},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }